import classNames from 'classnames/bind';
import React, { Component } from 'react';

import styles from './ErrorBoundary.module.scss';

import ContainerFullHeight from '@/components/ui/ContainerFullHeight';
import { PrimaryButton } from '@/components/ui/kit/Button';

const cx = classNames.bind(styles);

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.setVh = this.setVh.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error(error);
  }

  componentDidMount() {
    this.setVh();
    window.addEventListener('resize', this.setVh);
    window.addEventListener('orientationchange', this.setVh);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setVh);
    window.removeEventListener('orientationchange', this.setVh);
  }

  setVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
  }

  reload() {
    window.location.replace('/');
  }

  render() {
    if (this.state.hasError && !this.props.disabled) {
      return (
        <ContainerFullHeight className={cx('container')}>
          <div className={cx('form')}>
            <div className={cx('limiter')}>
              <div className={cx('message')}>
                An unexpected error occurred.
                <br />
                <span className={cx('accent')}>Please reload the page again.</span>
                <br />
                If it persists, contact the administrator.
              </div>
              <PrimaryButton text="Reload" type="wide" accent onClick={this.reload} />
            </div>
          </div>
        </ContainerFullHeight>
      );
    }

    return this.props.children;
  }
}
